import React, { Component } from 'react';

class EmailField extends Component {
  render() {
    const { children, value } = this.props;
    const href = `mailto:${value}`;

    return (
      <div className="form-group">
        <label>{children}</label>
        <span className="form-control">
          <a href={href}>{value}</a>
        </span>
      </div>
    );
  }
}

export default EmailField;



// WEBPACK FOOTER //
// ./src/shared/EmailField.js